import {Injectable} from '@angular/core';
import {RestangularModule, Restangular} from 'ngx-restangular';

@Injectable()
export class LossPreventionAccessService {

  constructor(private restangular: Restangular) {
  }

  getAllEmployeesLPTAccess() {
    return this.restangular.all('getAllEmployeesLPTAccess');
  }

  getTypeheadEmployeesMulti() {
    return this.restangular.one('getTypeheadEmployeesMulti');
  }

  getEmployeesLPTAccessFormData() {
    return this.restangular.one('getAllEmployeesFormData');
  }

  lptUserPermissionsCRUD() {
    return this.restangular.all('lptUserPermissionsCRUD');
  }

  getTypeheadEmployees() {
    return this.restangular.one('getTypeheadEmployees');
  }

  lptUserPermissionsUD(id) {
    return this.restangular.one('lptUserPermissionsCRUD/' + id);
  }

  getEmployeeLptAccess() {
    return this.restangular.one('getEmployeeLptAccess');
  }

  getEmployeeLptAccessNCR() {
    return this.restangular.one('getEmployeeLptAccessNCR');
  }

  getEmployeeLptAccessMSDE() {
    return this.restangular.one('getEmployeeLptAccessMSDE');
  }

  getCorrectiveActionLptAccess() {
    return this.restangular.one('getCorrectiveActionLptAccess');
  }

  getEmployeeLptAccessMSDEMonth() {
    return this.restangular.one('getEmployeeLptAccessMSDEMonth');
  }

  getEmployeeLptAccessEmp() {
    return this.restangular.one('getEmployeeLptAccessEmp');
  }

  getAccidentReportCloseAccess() {
    return this.restangular.one('getAccidentReportCloseAccess');
  }

  getReportSeverityLPTCloseAccess() {
    return this.restangular.one('getReportSeverityLPTCloseAccess');
  }

  checkConfidentialReportAccess() {
    return this.restangular.one('checkConfidentialReportAccess');
  }

  getDocumentEmailStatus() {
    return this.restangular.all('documentMasters');
  }

  getAllEmployeesReportAccess() {
    return this.restangular.all('getAllEmployeesReportAccess');
  }

  employeeReportAccessesCRUD() {
    return this.restangular.all('employee_report_accesses');
  }

  employeeReportAccessesUD(id) {
    return this.restangular.one('employee_report_accesses/' + id);
  }

  companyReportUD(id) {
    return this.restangular.one('company_reports/' + id);
  }

  companyBaseReportsAll() {
    return this.restangular.one('companyBaseReportsAll');
  }

  getSubCategoryDocumentBase() {
    return this.restangular.one('getSubCategoryDocumentBase');
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/loss-prevention-access.service.ts